export default "__VITE_PUBLIC_ASSET__9e26471c__"